import {create} from 'zustand'
import {ProposalFilter} from "../service/proposal.service";
import {useAuthStore} from "./auth.store";

function definePageSize(number: number) {
    const data = parseInt(localStorage.getItem("proposals_page_size") + "");
    if (isFinite(data) && !isNaN(data)) {
        return data;
    }
    return number;
}

export const usePropFilterStore = create<{
    filter: ProposalFilter,
    setFilter: (filter: ProposalFilter) => void
}>((set) => {

    const { can } = useAuthStore.getState();

    return ({
        filter: {
            page: 0,
            size: definePageSize(25),
            sortKey: 'createdAt',
            sortOrder: 'desc',
            favorite: false,
            id: '',
            phone: '',
            name: '',
            my: false,
            proposalStatuses: can('manage_proposals')
                ? ['AUTO_COMPLETE', 'MANUAL']
                : ["OWNER", "AGENT", "AUTO_COMPLETE", "MANUAL", "NO_RESPONSE", "REJECTED"],
        },
        setFilter: (filter: ProposalFilter) => {
            set({filter})
        }
    })
})
